import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes
} from '@backstage/theme';

export const syntonizeTheme = createUnifiedTheme({  
  palette: {  
    ...palettes.dark,
    primary: {  
      main: '#FFE500',
    },  
    secondary: {  
      main: '#FFE500',
    }, 
    error: {
      main: '#FFFFFF',
    },
    warning: {
      main: '#FFFFFF',
    },
    info: {
      main: '#FFFFFF',
    },
    success: {
      main: '#FFFFFF',
    },
    background: {  
      default: '#3A3A3A',
      paper: '#424242',
    },  
    banner: {
      info: '#FFE500',
      error: '#8c4351',
      text: '#343b58',
      link: '#565a6e',
    },
    errorBackground: '#8c4351',
    warningBackground: '#8f5e15',
    infoBackground: '#343b58',
    text: {
      primary: '#FFFFFF',
      secondary: '#FFFFFF',
    },
    navigation: {  
      submenu: {
        background: '#424242',
      },
      background: '#424242',
      indicator: '#FFE500',
      selectedColor: '#FFE500',
      color: '#ffffff',
      navItem: {  
        hoverBackground: '#535353',
      },
    },   
  },

  pageTheme: {
    home: genPageTheme({ colors: ['#000000'], shape: shapes.wave2 }),
    service: genPageTheme({
      colors: ['#0d456b', '#9d599f'],
      shape: shapes.wave,
    }),
  },
  fontFamily: '"DIN OT", Helvetica, Arial, sans-serif',
  components: {
    BackstageInfoCard: {
      styleOverrides: {
        
      }
    },
    BackstageSidebarItem: {
      styleOverrides: {
        root: {
          textDecorationLine: 'none'
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'DIN OT';
          src: url('../fonts/DINOT-Light.ttf') format('TrueType');
          font-weight: 300;
          font-style: normal;
        }
        
        @font-face {
          font-family: 'DIN OT';
          src: url('../fonts/DINOT.ttf') format('TrueType');
          font-weight: 400;
          font-style: normal;
        }
        
        @font-face {
          font-family: 'DIN OT';
          src: url('../fonts/DINOT-Medium.ttf') format('TrueType');
          font-weight: 500;
          font-style: normal;
        }
        
        @font-face {
          font-family: 'DIN OT';
          src: url('../fonts/DINOT-Bold.ttf') format('TrueType');
          font-weight: 700;
          font-style: normal;
        }
        .MuiTypography-root {
          color: #FFFFFF !important;
        }
        .MuiTypography-body1 {
          color: #FFFFFF !important;
        }
        .MuiTypography-body2 {
          color: #FFFFFF !important;
        }
        .MuiTypography-subtitle1 {
          color: #FFFFFF !important;
        }
        .MuiTypography-subtitle2 {
          color: #FFFFFF !important;
        }
        .MuiTypography-caption {
          color: #FFFFFF !important;
        }
       `,
    },
    MuiButton: {  
      styleOverrides: { 
        root: {  
          textTransform: 'none',
          color: '#FFFFFF',
        },  
        containedPrimary: {  
          '&:hover': {  
            backgroundColor: '#FFE500',
          },  
          color: '#3A3A3A',  
        },  
        containedSecondary: {  
          '&:hover': {  
            backgroundColor: '#FFE500',
          },  
          color: '#424242',  
        },  
      },  
    },
  }
}); 